import {
  Button,
  Collapse,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@material-ui/core"
import { Menu as MenuIcon } from "@material-ui/icons"
import { Location } from "@reach/router"
import { navigate } from "gatsby"
import React, { useState } from "react"
import styled from "styled-components"
import useResponsive from "../utils/useResponsive"
import smallLogo from "../images/AgSmallLogo.png"

export const NavSpacer = styled.div`
  margin-top: 50px;
`

const StyledNavBar = styled.div`
  text-align: right;
  padding: 4px 1rem;
  background-color: #ffffffd1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  > button {
    margin: 0 10px;
  }
  > img {
    padding: 3px;
    background-color: white;
    position: absolute;
    left: 5px;
    top: 5px;
    width: 60px;
  }
`

const NavBar = props => {
  const [expanded, setExpanded] = useState(false)
  const handleClick = sectionName => {
    navigate(sectionName)
  }
  const { smUp } = useResponsive()
  const locations = [
    { text: "HOME", link: "/", handleClick },
    { text: "SERVICES", link: "/services", handleClick },
    { text: "PORTFOLIO", link: "/portfolio", handleClick },
    { text: "ABOUT", link: "/about", handleClick },
    {
      text: "CONTACT",
      link: "/contact",
      handleClick,
    },
  ]
  const toggleExpanded = () => setExpanded(old => !old)
  return (
    <Location>
      {({ location }) => {
        return (
          <>
            {smUp && (
              <StyledNavBar>
                <img src={smallLogo} alt="AG logo" />
                {locations.map(({ text, handleClick, link }, index) => {
                  const youAreHere = link === location.pathname
                  return (
                    <Button
                      key={text}
                      style={{ fontWeight: youAreHere ? "bold" : "normal" }}
                      onClick={() => handleClick(link)}
                    >
                      {text}
                    </Button>
                  )
                })}
              </StyledNavBar>
            )}
            {!smUp && (
              <StyledNavBar>
                <img src={smallLogo} alt="AG logo" />

                <IconButton onClick={toggleExpanded}>
                  <MenuIcon />
                </IconButton>
                <Collapse in={expanded}>
                  <List component="div">
                    {locations.map(({ text, handleClick, link }) => {
                      return (
                        <ListItem
                          key={text}
                          button
                          onClick={() => {
                            handleClick(link)
                            setExpanded(false)
                          }}
                        >
                          <Typography variant="button">{text}</Typography>
                        </ListItem>
                      )
                    })}
                  </List>
                </Collapse>
              </StyledNavBar>
            )}
          </>
        )
      }}
    </Location>
  )
}

export default NavBar
